import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ApiClient} from "../../../tools/api-client";
import {recursiveNullToUndefined} from "../../../tools/recursive-null-to-undefined";
import {SleepReportData} from "./sleep-report-data";

@Injectable()
export class GetSleepReportDataService {

  constructor(private readonly apiClient: ApiClient) {
  }

  get(measurementId: number): Observable<SleepReportData> {
    return this.apiClient
      .get<SleepReportData>(`/api/measurements/${measurementId}/sleep-report-data`)
      .pipe(map(recursiveNullToUndefined));
  }
}
